import React, { useEffect, useState } from 'react';
import { startCase } from 'lodash';
import { PageTitle, useFetch, PseudoStates } from '@cordata/buffet';
import { useParams } from 'react-router-dom';

import MedicalEventForm from '~/components/MedicalEvent/Form';
import { authorizedInstance as axios } from '~/utils';

import { CitProvider } from '~/utils/cit/context';

const showField = (f) => {
  if (!f) return false;

  return f.show;
};

const MedicalEventsAdd = () => {
  const params = useParams();
  const [, aMedicalEvent] = useFetch('data/reference/reference-medical-event', {
    params: { medicalEventName: params.refMedicalEventName },
    instance: 'p',
  });
  const [medicalEvent, setMedicalEvent] = useState();
  const [status, setStatus] = useState('loading');
  const [loading, setLoading] = useState(true);
  const [providers, setProviders] = useState([]);

  useEffect(() => {
    if (aMedicalEvent) {
      setMedicalEvent(aMedicalEvent[0]);
      setStatus('success');
    }
  }, [aMedicalEvent]);

  useEffect(() => {
    setLoading(true);

    if (medicalEvent) {
      medicalEvent.attributes.propertyRules = JSON.parse(medicalEvent.attributes.propertyRules);

      if (showField(medicalEvent.attributes.propertyRules.provider)) {
        axios
          .get('providers/mv')
          .then(r => r.data.data)
          .then((r) => {
            setProviders(r);

            setLoading(false);
          });
      } else {
        setLoading(false);
      }
    }
  }, [medicalEvent]);

  return status === 'success' ? (
    <>
      <PageTitle>{`Add ${startCase(medicalEvent.attributes.medicalEventLabel)}`}</PageTitle>

      {!loading
        ? (
          <CitProvider>
            <MedicalEventForm
              {...params}
              providers={providers}
            />
          </CitProvider>
        ) : (
          <PseudoStates isLoading={loading} />
        )}
    </>
  ) :
    <PseudoStates status={status} />;
};

export default MedicalEventsAdd;
